// Section for import custom types -------------------------------------------------------------------------------------
import { ApiResponse } from '@/types/api/mansionestates';

// Endpoint URL
export const mansionestatesApiUrl = '/karte/api/v1/mansionestates/';

/**
 * @param {number}  limit - 文字列パラメータ
 * @param {string | boolean} prefecture - 任意のパラメータ(Closure構文)
 * @return {ApiResponse} 結果
 */
export const getMansionEstates = async (
  limit: number,
  prefecture: string | boolean | unknown = false,
): Promise<ApiResponse> => {
  try {
    // const response = await fetch(mansionestatesApiUrl);
    const requestUrl = prefecture
      ? `${mansionestatesApiUrl}?limit=${limit}&prefecture=${prefecture}`
      : `${mansionestatesApiUrl}?limit=${limit}`;
    const response = await fetch(requestUrl);

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    const data: ApiResponse = await response.json();
    return data;
  } catch (error) {
    console.error('API fetch failed:', error);
    throw error;
  }
};
